import { modalAnatomy as parts } from '@chakra-ui/anatomy'
import { createMultiStyleConfigHelpers } from '@chakra-ui/styled-system'

const { definePartsStyle, defineMultiStyleConfig } =
  createMultiStyleConfigHelpers(parts.keys)

const baseStyle = definePartsStyle({
  // define the part you're going to style
  body: {
    borderTopWidth: 1,
    borderTopColor: 'gray.200',
    borderTopStyle: 'solid',
    py: 5
  },
  footer: {
    borderTopWidth: 1,
    borderTopColor: 'gray.200',
    borderTopStyle: 'solid'
  }
})

export const modalTheme = defineMultiStyleConfig({
  baseStyle
})
